export const locationHasValidCoordinates = (location: ExternalLocationType) => location.longitude && location.latitude

export const locationHasInvalidCoordinates = (location: ExternalLocationType) => !locationHasValidCoordinates(location)
